
export const colCountByScreen = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4
};

export const categoryType = {
  Identity: 1,
  Contact: 2,
  Leave: 3,
  OverTime: 4,
  Advance: 5,
  TravelExpense: 6,
  Education: 7,
  Account: 8,
  Banking: 9,
  Policy: 10,
  Workplace: 11,
  Documents: 12,
  InventoryAssignment: 13,
  Seyahat: 14,
  Kariyer: 15,
  Salary: 16,
  Family: 17,
  EmploymentCheckList: 18,

}

export const categories = [
  {
    id: categoryType.Identity,
    text: 'Kimlik ',
  },
  {
    id: categoryType.Contact,
    text: 'İletişim ',
  }, {
    id: categoryType.Workplace,
    text: 'İşyeri ',
  }, {
    id: categoryType.Salary,
    text: 'Ücret Bilgisi ',
  }, {
    id: categoryType.Banking,
    text: 'Banka Hesap ',
  }, {
    id: categoryType.Policy,
    text: 'Sigorta ',
  }, {
    id: categoryType.Kariyer,
    text: 'Kariyer',
  }, {
    id: categoryType.Education,
    text: 'Eğitim',
  },
  {
    id: categoryType.Leave,
    text: 'İzin',
  }, {
    id: categoryType.OverTime,
    text: 'Fazla Mesai',
  }, {
    id: categoryType.Advance,
    text: 'Avans',
  }, {
    id: categoryType.TravelExpense,
    text: 'Harcırah',
  }, {
    id: categoryType.Seyahat,
    text: 'Seyahat',
  }, {
    id: categoryType.Documents,
    text: 'Belgeler',
  }, {
    id: categoryType.InventoryAssignment,
    text: 'Zimmet',
  }, {
    id: categoryType.Family,
    text: 'Aile Bilgisi',
  }, {
    id: categoryType.Account,
    text: 'Kullanıcı Yönetimi',
  }, {
    id: categoryType.EmploymentCheckList,
    text: 'İşe Giriş Evrakları',
  },
];


